<script setup lang="ts">
// Components
import ProductionEventTable from './standardEvent/production.vue';
import OffProductionEventTable from './standardEvent/offProduction.vue';
import WeeklyEventTable from './standardEvent/weekly.vue';

// Store
const { standardResponse } = storeToRefs(standardStore());
</script>
<template>
  <production-event-table v-if="standardResponse?.type === 'production'" :production-events="standardResponse.items" />
  <production-event-table v-else-if="standardResponse?.type === 'fabrication_order'" :production-events="standardResponse.items" />
  <weekly-event-table v-else-if="standardResponse?.type === 'weekly'" :events="standardResponse.items" />
  <off-production-event-table v-else-if="standardResponse?.type === 'off_production'" :production-events="standardResponse.items" />
</template>
